<div class="login-container">

  <!-- SINISTRA — brand -->
  <div class="login-brand">
    <div class="brand-content">
      <img src="nyzed-wordmark.png" alt="Nyzed" class="brand-logo-full" />
      <h1 class="brand-title">Bentornata.</h1>
      <p class="brand-tagline">{{ "login.tagline" | translate }}</p>
      <div class="brand-features">
        <div class="brand-feature">
          <strong class="feature-label">{{ "login.feature1_label" | translate }}</strong>
          <span>{{ "login.feature1" | translate }}</span>
        </div>
        <div class="brand-feature">
          <strong class="feature-label">{{ "login.feature2_label" | translate }}</strong>
          <span>{{ "login.feature2" | translate }}</span>
        </div>
        <div class="brand-feature">
          <strong class="feature-label">{{ "login.feature3_label" | translate }}</strong>
          <span>{{ "login.feature3" | translate }}</span>
        </div>
      </div>
    </div>
    <div class="brand-decoration"></div>
  </div>

  <!-- DESTRA — form -->
  <div class="login-form-side">
    <div class="login-card">
      <h2>{{ 'login.title' | translate }}</h2>

      <form (ngSubmit)="onSubmit()">
        <div class="input-group">
          <input
            type="text"
            [(ngModel)]="username"
            name="username"
            required
            [placeholder]="'login.username_or_email' | translate"
            class="input-field"
            [class.input-error]="errorMsg"
          />
        </div>
        <div class="input-group password-group">
          <input
            [type]="showPassword ? 'text' : 'password'"
            [(ngModel)]="password"
            name="password"
            required
            [placeholder]="'login.password' | translate"
            class="input-field"
            [class.input-error]="errorMsg"
            appCapsLock
            #capsPwd="capsLock"
          />
          <button
            type="button"
            class="password-toggle"
            (click)="togglePasswordVisibility()"
            [attr.aria-label]="(showPassword ? 'common.hide_password' : 'common.show_password') | translate"
          >
            <svg *ngIf="!showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
              <path d="M1.5 12s4-7.5 10.5-7.5S22.5 12 22.5 12s-4 7.5-10.5 7.5S1.5 12 1.5 12Z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
            <svg *ngIf="showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 3l18 18"/>
              <path d="M10.6 5.2c.45-.05.92-.08 1.4-.08 6.5 0 10.5 7.5 10.5 7.5a17.9 17.9 0 0 1-4.14 5.02M6.5 6.5C3.6 8.3 1.5 12 1.5 12s4 7.5 10.5 7.5c1.7 0 3.2-.4 4.5-1.05"/>
              <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/>
            </svg>
          </button>
          <small class="caps-hint" *ngIf="capsPwd.capsOn">
            <app-icon name="alert" [size]="14" /> {{ 'common.caps_lock_on' | translate }}
          </small>
        </div>

        <label class="remember-row">
          <input type="checkbox" [(ngModel)]="remember" name="remember" />
          <span>{{ 'login.remember' | translate }}</span>
        </label>

        <div class="error-msg" *ngIf="errorMsg">
          {{ errorMsg }}
          <a *ngIf="emailNotVerified" routerLink="/conferma-email">{{ 'login.resend_confirmation_link' | translate }}</a>
        </div>

        <button type="submit" class="submit-button">
          {{ 'login.submit' | translate }}
        </button>
      </form>

      <div class="or-divider"><span>{{ 'login.or_divider' | translate }}</span></div>

      <app-google-signin-button
        [clientId]="googleClientId"
        [remember]="remember"
        (success)="onGoogleSuccess($event)"
        (failure)="onGoogleFailure($event)">
      </app-google-signin-button>

      <div class="bottom-links">
        <p class="register-link">
          {{ 'login.noAccount' | translate }}
          <a (click)="register()">{{ 'login.register' | translate }}</a>
        </p>
        <a routerLink="/forgot-password" class="forgot-link">{{ "login.forgot_password" | translate }}</a>
      </div>
    </div>
  </div>

</div>